import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Typography, Link, Paper, Button, Divider } from '@mui/material'
import { CONTACT_EMAIL } from '../../Constants'
import ROUTES from '../../routesConfig'
import {
  contentColumnMaxWidthSx,
  contentColumnPageShellSx
} from '../UI/contentColumn'

const AboutPage = () => {
  const appVersion = process.env.REACT_APP_VERSION

  return (
    <Box sx={contentColumnPageShellSx}>
      <Box sx={{ ...contentColumnMaxWidthSx, overflowX: 'hidden' }}>
        <Box sx={{
          bgcolor: '#0B0F19',
          minHeight: 'calc(100svh - 80px)',
          height: 'calc(100svh - 80px)',
          borderRadius: 2,
          p: 3,
          overflowX: 'hidden',
          overflowY: 'auto',
          width: '100%',
          boxSizing: 'border-box',
          maxWidth: '100%',
          color: '#E6E9EF',
          display: 'flex',
          flexDirection: 'column',
          gap: 4
        }}>
          <Box>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#E6E9EF', mb: 2 }}>
              About Anear Me
            </Typography>
            {appVersion ? (
              <Typography
                variant="body2"
                sx={{ mt: -1.25, mb: 2.25, color: 'rgba(230,233,239,0.75)' }}
              >
                Version: {appVersion}
              </Typography>
            ) : null}

            <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'rgba(230,233,239,0.9)', mb: 2 }}>
              Turn your night out into an unexpected adventure with the people around you—whether you know them or not. Anear runs directly in your mobile browser, letting you jump into games and activities without downloading a thing. Just scan a QR code to join the fun and start connecting. One person can start, and strangers nearby can join in.
            </Typography>

            <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'rgba(230,233,239,0.9)', mb: 2 }}>
              Our philosophy is "must be present to win." We use technology to spark real-world interaction, helping you connect with those around you rather than staring at a screen alone.
            </Typography>

            <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'rgba(230,233,239,0.9)' }}>
              For businesses and community hubs, Anear offers a powerful way to engage visitors. By hosting on-premise events, venues can create memorable moments that bring customers back and build a vibrant local community.
            </Typography>
          </Box>

          <Box>
            <Typography variant="body1" sx={{ lineHeight: 1.6, color: 'rgba(230,233,239,0.9)' }}>
              Discover and join events in progress through "What's Nearby" or "My Events," or create your own event directly from the Apps page.
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              bgcolor: 'rgba(255,255,255,0.08)',
              p: 2.5,
              borderRadius: 2,
              border: '1px solid rgba(255,255,255,0.1)'
            }}
          >
            <Typography variant="h6" sx={{ color: '#E6E9EF', mb: 1, fontWeight: 600 }}>
              Have an App Idea?
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              We'd love to hear from you. Contact us at:
            </Typography>
            <Link
              href={`mailto:${CONTACT_EMAIL}`}
              sx={{
                display: 'block',
                mt: 1,
                color: '#60A5FA', // blue-400
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': {
                  textDecoration: 'underline',
                  color: '#93C5FD' // blue-300
                }
              }}
            >
              {CONTACT_EMAIL}
            </Link>
          </Paper>

          <Box>
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />
            <Button
              component={RouterLink}
              to={ROUTES.APPS}
              variant="contained"
              color="primary"
              sx={{ fontWeight: 800 }}
            >
              Explore Apps
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AboutPage
